export default {
  allAdditionalInformations: [],
  additionalInformation: {},
}
